import _ from 'lodash';
export class PubSub {
    constructor() {
        this.listeners = [];
    }
    subscribe(listenerFn) {
        if (listenerFn !== undefined) {
            const listenerIdx = this.listeners.push(listenerFn);
            return () => {
                this.listeners.splice(listenerIdx);
            };
        }
        return _.noop;
    }
    publish(value) {
        this.listeners.forEach(listener => listener(value));
    }
}
//# sourceMappingURL=pub-sub.js.map